module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-41.97c6ac5e.png";